import { Injectable } from '@angular/core';


@Injectable()
export class LocalizationService {
  CurrentLanguagePrefix: string;
  URLAuthServer: string;
}
